import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { KeycloakProfile } from 'keycloak-js';
import { defer, Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { UserContextSupplier } from '../supplier';

@Injectable()
export class KeycloakUserSupplier extends UserContextSupplier {
	private _userProfile$: Observable<KeycloakProfile>;

	constructor(private readonly keycloakService: KeycloakService) {
		super();
		this._userProfile$ = defer(() =>
			this.keycloakService.loadUserProfile()
		).pipe(
			shareReplay(1),
		);
	}

	username$(): Observable<string> {
		return this._userProfile$.pipe(map(({ username }) => username));
	}

	profile$(): Observable<KeycloakProfile> {
		return this._userProfile$;
	}
}
